module.exports = ".mat-column-code {\n  max-width: 10rem;\n}\n"